import { Flex } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Alert from 'components/Alert';
import LazySvg from 'components/LazySvg';
import If from 'components/If';
import {
  selectIsEligibleForFinishAccountSetup,
  selectIsFinishAccountSetupBannerClosed,
} from 'services/ctp/ctpSelectors';
import { setIsFinishAccountSetupBannerClosed } from 'services/ctp/ctpSlice';
import { QaCommonComponent, QaCreditCardCapture } from 'testdata/constants';
import CompleteMySetupCta from '../complete-my-setup-cta';
import styles from './index.module.scss';

function AlertDescription() {
  return (
    <Flex vertical>
      Add your credit card to keep your access. No charges unless you choose to
      renew.
      <CompleteMySetupCta
        ctaText='Complete my setup.'
        className={styles.ctaText}
      />
    </Flex>
  );
}

function FinishSetupAccountBanner() {
  const dispatch = useAppDispatch();
  const isEligibleForFinishAccountSetup = useAppSelector(
    selectIsEligibleForFinishAccountSetup,
  );
  const isFinishAccountSetupBannerClosed = useAppSelector(
    selectIsFinishAccountSetupBannerClosed,
  );
  const shouldShowAlert =
    isEligibleForFinishAccountSetup && !isFinishAccountSetupBannerClosed;

  const handleBannerClose = () => {
    dispatch(setIsFinishAccountSetupBannerClosed(true));
  };

  return (
    <If condition={shouldShowAlert}>
      <Alert
        className={styles.finishAccountSetupBanner}
        message='Finish setting up your account.'
        description={<AlertDescription />}
        type='info'
        icon={<LazySvg name='tag' className={styles.icon} />}
        showIcon
        closable={{
          'aria-label': 'close',
          closeIcon: (
            <LazySvg
              name='close'
              className={`${styles.icon} ${styles.closeIcon}`}
              data-qa-selector={QaCommonComponent.buttonModalClose}
            />
          ),
        }}
        onClose={handleBannerClose}
        data-qa-selector={QaCreditCardCapture.textBanner}
      />
    </If>
  );
}

export default FinishSetupAccountBanner;
